import React from "react";
import { useTranslation } from "react-i18next";
import { TransformedOrder } from "../types/orderApiTypes";
import { decodeHtmlEntities } from "../../../../common/helpers/decodeHtmlEntities";

interface OrderItemsSummaryProps {
  order: TransformedOrder;
}

const OrderItemsSummary: React.FC<OrderItemsSummaryProps> = ({ order }) => {
  const { t } = useTranslation();
  const items = order.items;

  return (
    <div className="order-page__items-summary">
      <h3 className="order-page__items-summary-title">
        {t("orderReview.itemsTitle", "Order Items")}
        <span className="order-page__items-summary-count">{items.length}</span>
      </h3>

      <div className="order-page__items-summary-list">
        {items.map((item) => {
          const image = item.images[0] || null;
          const decodedName = decodeHtmlEntities(item.name);

          return (
            <div key={item.id} className="order-page__items-summary-item">
              {/* Image Column */}
              <div className="order-page__items-summary-image">
                {image ? (
                  <img
                    src={image.thumbnail}
                    alt={decodeHtmlEntities(image.alt) || decodedName}
                  />
                ) : (
                  <div className="placeholder-image" />
                )}
                <span className="order-page__items-summary-qty-badge">
                  {item.quantity}
                </span>
              </div>

              {/* Details Column */}
              <div className="order-page__items-summary-details">
                <span className="order-page__items-summary-name">
                  {decodedName}
                </span>
                {item.variation.length > 0 && (
                  <div className="order-page__items-summary-meta">
                    {item.variation.map((v) => (
                      <span key={v.attribute}>
                        {v.attribute}: {decodeHtmlEntities(v.value)}
                      </span>
                    ))}
                  </div>
                )}
              </div>

              {/* Price Column */}
              <div className="order-page__items-summary-price">
                {item.formattedCalculatedLineTotal}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OrderItemsSummary;
